export interface Editable {
  history(): string[];
  enable(id: string): void;
  disable(id: string): number;
  status(id: string): boolean;
  clear(): void;
}

export class EditableQuota implements Editable {
  private _quotas: string[] = [];

  public history(): string[] {
    return this._quotas;
  }

  public enable(id: string): void {
    this._quotas.push(id);
  }

  public disable(id: string): number {
    let index = this._quotas.findIndex((quota) => quota === id);
    this._quotas.splice(index, 1);

    if (index >= this._quotas.length) {
      return 0;
    }

    return index;
  }

  public status(id: string): boolean {
    return this._quotas.some((quota) => quota === id);
  }

  public clear(): void {
    this._quotas = [];
  }
}

export class EditableSupplierQuota {
  private _supplier: string = '';

  public current(): string {
    return this._supplier;
  }

  public enable(quotaId: string, supplierId: string): void {
    this._supplier = this._id(quotaId, supplierId);
  }

  public disable(): void {
    this._supplier = '';
  }

  public status(quotaId: string, supplierId: string): boolean {
    return this._supplier === this._id(quotaId, supplierId);
  }

  private _id(quotaId: string, supplierId: string): string {
    return `${quotaId} ${supplierId}`;
  }
}
